export const selectPictures = state => state.content.pictures;
export const selectVideos = state => state.content.videos;
export const selectBio = state => state.content.bio;
export const selectContacts = state => state.content.contacts;
export const selectSchedule = state => state.content.schedule;
export const selectEmail = state => state.content.email;
export const selectSocials = state => state.content.socials;
export const selectUploadInfo = state => state.content.uploadInfo;
export const selectAdminPictures = state => state.content.adminPictures;
export const selectAdminVideos = state => state.content.adminVideos;
export const selectAdminBio = state => state.content.adminBio;
export const selectAdminContacts = state => state.content.adminContacts;
export const selectAdminEmail = state => state.content.adminEmail;
export const selectAdminSocials = state => state.content.adminSocials;
export const selectUploadError = state => state.content.uploadError;
export const selectEmailError = state => state.content.emailError;
export const selectEmailMessage = state => state.content.emailMessage;
export const selectAdminSchedule = state => state.content.adminSchedule;
export const selectAdminError = state => state.content.adminError;
export const selectAdminMessage = state => state.content.adminMessage;